import { render, staticRenderFns } from "./PlanStep3.vue?vue&type=template&id=8240f97a&scoped=true"
import script from "./PlanStep3.vue?vue&type=script&lang=js"
export * from "./PlanStep3.vue?vue&type=script&lang=js"
import style0 from "./PlanStep3.vue?vue&type=style&index=0&id=8240f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8240f97a",
  null
  
)

export default component.exports